import { ProxyVoteIcon } from "./ProxyVoteIcon";

export default ProxyVoteIcon;